/* eslint-disable */
import React from "react";
import { m } from "framer-motion";

// ----------------------------------------------------------------

const animationVariants = {
  initial: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: {
      duration: 2,
      ease: "easeIn",
    },
  },
};

function Logo() {
  return <svg></svg>;
}

export default Logo;
